import { FC, JSX } from 'react';
import { useHistory } from 'react-router';

import { EvSpinner } from '@evinced-private/ui-common';

import { getUnauthorized403Page } from '../helpers/RoutesHelper';
import { useUserTenant } from '../providers/userTenantProvider/UserTenantProvider';

export const withLimitedAccess = (WrappedComponent: FC): FC => {
	return (props): JSX.Element => {
		const { isReady, hasAdminPermissions } = useUserTenant();
		const history = useHistory();
		// While the provider is still loading the user / roles, `hasAdminPermissions()`
		// returns `false` for reasons that have nothing to do with actual permissions.
		// Redirecting in that window flashes admins to /unauthorized (visible in prod
		// on cold loads) and races the app render on CI (no Auth0 handshake latency to
		// mask it), so hold at a spinner until we have a trustworthy answer.
		if (!isReady) {
			return <EvSpinner />;
		}
		if (!hasAdminPermissions()) {
			history.replace(getUnauthorized403Page());
			return null;
		}

		return <WrappedComponent {...props} />;
	};
};
